//include 8
jQuery(function(){
    // re-init components whose width/height is computed while the .showmore was still display:none (e.g. slick sliders)
    function reinitializeShowMoreChildren(target) {
        target.find(".slick-initialized").each(function () {
            var exposed = $(this).data("exposed");
            if (!!exposed && !!exposed.reinitialize)
                exposed.reinitialize();
        });
        target.find(".more-wrapper").each(function () {
            var exposed = $(this).data("show-more");
            if (!!exposed && !!exposed.init)
                exposed.init();
        });
    }

    var privateFunctions = {
        initShowMore($this){
            if(Foundation.MediaQuery.current == "small" && $this.data("xs-max-rows")){
                var maxRowXs = parseInt($this.data("xs-max-rows"));

                if(maxRowXs > 0){
                    var $readMoreContent = $this;
                    var $visibleContent = $readMoreContent.prev();
                    var visibleElementsNr = $visibleContent.find("div.item").length;

                    var $newHiddenElements = "";
                    var $newVisibleElements = "";

                    if(visibleElementsNr > maxRowXs) {
                        var i = 0;
                        $visibleContent.find("div.item").each(function () {
                            i ++;

                            if(i > maxRowXs){
                                $newHiddenElements += '<div class="'+$(this).attr("class")+'">' + $(this).html() + '</div>';

                                $(this).remove();
                            }
                        });

                        $readMoreContent.prepend($newHiddenElements);
                    }
                    else {
                        var i = visibleElementsNr;

                        $readMoreContent.find("div.item").each(function () {
                            i ++;

                            if(i <= maxRowXs){
                                $newVisibleElements += '<div class="'+$(this).attr("class")+'">' + $(this).html() + '</div>';

                                $(this).remove();
                            }
                        });

                        $visibleContent.prepend($newVisibleElements);

                        if($readMoreContent.find("div.item").length == 0){
                            $readMoreContent.next().hide();
                        }
                    }
                }
            }

            var dimensions = window.pixelpoint.getElementDimensions($this);
            var multiplier = null;

            if ($this.data("multiply-height")) {
                multiplier = parseInt($this.data("multiply-height"));
                if (isNaN(multiplier))
                    multiplier = 1;
                dimensions.height *= multiplier;
            }
            if ($this.data("multiply-width")) {
                multiplier = parseInt($this.data("multiply-width"));
                if (isNaN(multiplier))
                    multiplier = 1;
                dimensions.width *= multiplier;
            }

            $this.data("width", dimensions.width);
            $this.data("height", dimensions.height);
            if (!$this.hasClass("collapsed")) {
                $this.css("max-height", dimensions.height);
            }


        },
        open($this){
            if($this.length == 0)
                return;
            if($this.hasClass('active'))
                this.toggle($this);
        },
        close($this){
            if($this.length == 0)
                return;
            if(!$this.hasClass('active'))
                this.toggle($this);
        },
        toggle($this){
            $this.toggleClass('active');
            var id = $this.attr('data-target');
            var label = $this.siblings('label:first');
            label.toggleClass('active');
            if ($this.attr('buttontext')) {
                label = $this;
            }

            if (label.length == 0) {
                label = $this.find(".text[data-active]");
            }

            var target = $('[data-id=' + id + ']');

            if (target.data("height")) {
                if (target.hasClass("collapsed")) {
                    target.removeClass("collapsed").addClass("collapsing");
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleOpenBefore, target);
                    setTimeout(function () {
                        // the stored height comes from a detached clone and can be too small, so never go below the real content height
                        target.removeClass("collapsing").css("max-height", Math.max(target.data("height") + 150, target.prop("scrollHeight")));

                        setTabIndexForElements(target, "0");
                        focusFirstFocusableElement(target);
                        // width is already correct here (only max-height is still animating), no need to wait for transitionend
                        reinitializeShowMoreChildren(target);

                        window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleOpenAfter, target);
                    }, 10);
                } else {
                    target.addClass("collapsing").removeAttr("style");

                    var $scrollToElement = $this.prev();

                    if($this.parent().hasClass('scrollUpOnCloseReadMore')){
                        $scrollToElement = $this.parent();
                    }
                    else if($this.parent().parent().hasClass('scrollUpOnCloseReadMore')){
                        $scrollToElement = $this.parent().parent();
                    }
                    else if($this.parent().parent().parent().hasClass('scrollUpOnCloseReadMore')){
                        $scrollToElement = $this.parent().parent().parent();
                    }
                    else{}
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleCloseBefore, target);
                    target.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function () {
                        if($this.hasClass("read-more-button-new")){
                            $("html, body").animate({scrollTop: $scrollToElement.offset().top - $('.header-wrapper .header').height() - 30}, 800);
                        }
                        else{
                            $("html, body").animate({scrollTop: $scrollToElement.offset().top - $('.header-wrapper .header').height() - 10}, 800);
                        }

                        setTabIndexForElements(target, "-1");

                        window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleCloseAfter, target);
                    });
                }
            } else {
                target.toggleClass('collapsed');
                if(target.hasClass("collapsed")){
                    setTabIndexForElements(target, "-1");

                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleCloseAfter, target); 
                }
                else{
                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleOpenBefore, target);

                    setTabIndexForElements(target, "0");
                    focusFirstFocusableElement(target);
                    // no CSS transition happens on this branch, so the transitionend handler below never fires - reinit here instead
                    reinitializeShowMoreChildren(target);

                    window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.toggleOpenAfter, target);
                }
            }
            if (label) {
                var active_text = label.attr('data-active');
                var text = label.html();
                label.html(active_text);
                label.attr('data-active', text);
                label.attr('title', active_text);
            }

            if($this.data("default-title") && $this.data("close-title")){
                var title = "";

                if($this.hasClass("active")){
                    title = $this.data("default-title");
                }
                else{
                    title = $this.data("close-title");
                }

                $this.attr("title", title);
            }
        }
    }

    $('.showmore').each(function () {
        privateFunctions.initShowMore($(this));
    });
    window.pixelpoint.ppComponents.showMore = {
        init: privateFunctions.initShowMore,
        open: privateFunctions.open,
        close: privateFunctions.close,
        toggle: privateFunctions.toggle
    };

    $('body').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', '.showmore', function (e) {
        var target = $(e.target);
        if (target.hasClass("collapsing")) {
            target.removeClass("collapsing").addClass("collapsed");
        }
        reinitializeShowMoreChildren(target);
    });

    // $('button.einklappen').click(function (e) {
    $('body').on('click','button.einklappen', function (e) {
        e.preventDefault();
        var $this = $(this);
        privateFunctions.toggle($this);
    });
});

 // Helper function to focus first focusable element
function focusFirstFocusableElement(container) {
    var focusableElements = container.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])').filter(':visible');
    if (focusableElements.length > 0) {
        focusableElements.first().focus();
    }
}

// Helper function to set tabindex for all focusable elements within a container
function setTabIndexForElements(container, tabIndex) {
    var focusableElements = container.find('a, button, input, textarea, select, [tabindex]');
    focusableElements.each(function() {
        var element = $(this);
        if (element.attr('data-tabindex') !== undefined) {
            return; // Skip this element, preserve its custom tabindex
        }
        element.attr('tabindex', tabIndex);

        // select2 has ah special structure, we need to hide element to make it not focusable
        if(element.parent().find('.select2').length > 0) {
            element.parent().find('.select2').each(function() {
                $(this).css('display', tabIndex === "-1" ? "none" : "inline-block");
            });
        }
    });
}
